import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { POST_LOGIN_REDIRECT_KEY } from './authCodeFlow';
import { LoadingPage } from '@src/components/LoadingPage';
import type { ReactNode } from 'react';

/**
 * Route guard. During boot detection, shows a loading state instead of
 * redirecting. Once boot is ready, if there's no valid session, redirect
 * to /login and stash the original path so the callback handler can return
 * the user there afterwards.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
    const { isAuthenticated, bootPhase } = useAuth();
    const location = useLocation();

    if (bootPhase === 'detecting') {
        return <LoadingPage />;
    }

    if (!isAuthenticated) {
        const from = location.pathname + location.search;
        sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, from);
        return <Navigate to="/login" replace />;
    }

    return <>{children}</>;
}
